export function RouteFallback() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-paper text-sm font-semibold text-ink/60">
      Ładowanie…
    </div>
  )
}
